if (process.browser) {
  window.onNuxtReady(({ $store, $route, $router }) => {
    // Close any open modal upon navigation
    $router.beforeEach((to, from, next) => {
      $store.dispatch('modal/closeModal')
      next()
    })
  })
}
